import { LocalizationProvider as I10nProvider } from '@im/react-localization';
import React, { ReactNode } from 'react';
import { getSameOriginApiBasePath } from '../../query';
// import { useSiteConfig } from '../../config';

type Props = {
  children: ReactNode;
};

// const win = window as any;
// const temp_session_Id = uuidV4();
// const translationpreloadResourcesMap: {
//   [environment: string]: string[];
// } = {
//   development: ['Common', 'myprofile'],
//   production: ['Common', 'myprofile'],
//   productionbeta: ['Common', 'myprofile'],
//   productionbetax: ['Common', 'myprofile'],
//   staging: ['Common', 'myprofile'],
//   staging2: ['*'],
// };

export function LocalizationProvider(props: Props) {
  const { children } = props;

  // const buildVars = useBuildVars();
  // const siteConfig = useSiteConfig();

  // const dd_session_id =
  //   win.DD_RUM?.getInternalContext()?.session_id || temp_session_Id;

  // const isNonProd =
  //   buildVars.buildEnvironment.startsWith('staging') ||
  //   buildVars.buildEnvironment === 'development';

  const url = `${getSameOriginApiBasePath()}/shared/v1/translations`;

  return (
    <I10nProvider
      // apiHeaders={{ 'IM-DDSessionId': dd_session_id }}
      appId={'cep'}
      defaultLocale={'en-US'}
      // preloadResources={
      //   translationpreloadResourcesMap[`${buildVars.buildEnvironment}`]
      // }
      // showLogs={isNonProd}
      showLogs={false}
      supportedLocales={['en-US']}
      url={url}
      useApi={true}
    >
      {children}
    </I10nProvider>
  );
}
